/* eslint-disable */
import axios from "axios";
import { toast } from "react-toastify";
import i18n from "../../i18n";
import { baseUri } from "../../uri";
import {
  GET_ROOT_DOCUMENTS_AND_DIRECTORIES,
  GET_DIRECTORY_DOCUMENTS,
  GET_DOCUMENT,
  ADD_DOCUMENT_FUND,
  ADD_DOCUMENT,
  ADD_DIRECTORY,
  DELETE_DOCUMENT_PART,
  DELETE_DIRECTORY,
  GET_DOCUMENT_FUND,
  DOCUMENT_IMPORT,
  CHECK_DOCUMENT_IMPORT,
  GET_DOCUMENTS_PART,
  ADD_DOCUMENT_PART,
  ADD_ENVELOPE_PART,
  GET_DOCUMENT_PART,
  DELETE_ENVELOPE_PART,
  DELETE_DOCUMENT,
} from "../actionTypes";

export const documentImport =
  (file: FormData) =>
  async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axios({
        method: "post",
        url: `${baseUri}/connector-file/standard/file-import/clients/documents/import`,
        data: file,
      });
      dispatch({
        type: DOCUMENT_IMPORT,
        payload: res.data,
      });
      toast.success(i18n.t("SUCCESS"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
export const checkDocumentImport =
  (file: FormData) =>
  async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axios.post(
        `${baseUri}/connector-file/standard/file-import/clients/documents/check`,
        file
      );
      dispatch({
        type: CHECK_DOCUMENT_IMPORT,
        payload: res.data,
      });
      toast.success(i18n.t("SUCCESS"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const getRootDocumentsAndDirectories =
  () => async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = await axios.get(
        `${baseUri}/service-document/v1/shared-documents`
      );
      dispatch({
        type: GET_ROOT_DOCUMENTS_AND_DIRECTORIES,
        payload: res.data,
      });
      return true;
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
  };
export const getDirectoryDocuments =
  (directoryId: string, type?: any, personId?: any) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res =
        type === "fund"
          ? await axios.get(
              `${baseUri}/service-document/v1/persons/${personId}/${directoryId}`
            )
          : await axios.get(
              `${baseUri}/service-document/v1/shared-documents/directories/${directoryId}`
            );
      dispatch({
        type: GET_DIRECTORY_DOCUMENTS,
        payload: res.data,
      });
      return true;
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
  };
export const getDocument =
  (documentId: string) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = await axios({
        method: "get",
        url: `${baseUri}/service-document/v1/shared-documents/documents/${documentId}`,
        responseType: "blob",
      });
      dispatch({
        type: GET_DOCUMENT,
        payload: res.data,
      });
      return true;
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
  };
export const addDocument =
  (documentName: any, directoryId: any, file: FormData) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      let data: any = {};
      if (!!directoryId) {
        data = {
          name: documentName,
          directoryId: directoryId,
        };
      } else {
        data = {
          name: documentName,
        };
      }
      file.append(
        "data",
        new Blob([JSON.stringify(data)], { type: "application/json" })
      );
      const res = await axios({
        method: "post",
        url: `${baseUri}/service-document/v1/shared-documents/documents`,
        data: file,
      });
      dispatch({
        type: ADD_DOCUMENT,
        payload: res.data,
      });
      return true;
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
  };
export const addDirectory =
  (name: any, id: any, type?: any, defaultDoc?: any) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res =
        type === "DIRECTORY_FUND"
          ? await axios.post(`${baseUri}/service-document/v1/persons/${id}`, {
              isDeleted: false,
              comment: "",
              key: defaultDoc ? "customDocumentDefault" : "customDocument",
              isPrivate: false,
              name: name,
            })
          : await axios({
              method: "post",
              url: `${baseUri}/service-document/v1/shared-documents/directories`,
              data: { name: name, parentDirectoryId: id },
            });
      dispatch({
        type: ADD_DIRECTORY,
        payload: res.data,
      });
      return true;
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
  };
export const deleteDocument =
  (id: any, type?: any, fundId?: any, dirId?: any) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = type
        ? await axios({
            method: "delete",
            url: `${baseUri}/service-document/v1/persons/${fundId}/${dirId}/document/${id}`,
          })
        : await axios({
            method: "delete",
            url: `${baseUri}/service-document/v1/shared-documents/documents/${id}`,
          });
      dispatch({
        type: DELETE_DOCUMENT,
        payload: res.data,
      });
      return true;
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
  };
export const deleteDirectory =
  (id: any, type?: any, fundId?: any) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res =
        type === "fund"
          ? await axios({
              method: "delete",
              url: `${baseUri}/service-document/v1/persons/${fundId}/${id}`,
            })
          : await axios({
              method: "delete",
              url: `${baseUri}/service-document/v1/shared-documents/directories/${id}`,
            });
      dispatch({
        type: DELETE_DIRECTORY,
        payload: res.data,
      });
      return true;
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
  };

export const addDocumentFund =
  (documentName: any, personId: any, file: FormData, folderId?: any) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      let data: any = {};
      if (!!personId) {
        data = {
          name: documentName,
          personId: personId,
        };
      } else {
        data = {
          name: documentName,
        };
      }
      file.append(
        "data",
        new Blob([JSON.stringify(data)], { type: "application/json" })
      );

      const res = await axios({
        method: "post",
        url: `${baseUri}/service-document/v1/persons/${personId}/${folderId}/document`,
        data: file,
      });
      dispatch({
        type: ADD_DOCUMENT_FUND,
        payload: res.data,
      });
      return true;
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
  };

export const getFundEnvelopes =
  (fundId: string) =>
  async (dispatch: (arg0: { type: string; payload: any }) => void) => {
    try {
      const res = await axios({
        method: "get",
        url: `${baseUri}/service-document/v1/persons/${fundId}`,
      });
      dispatch({
        type: GET_DOCUMENT_FUND,
        payload: res.data,
      });
      return true;
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
  };

export const getPartEnvelopes =
  (fundId: string, partId: string) =>
  async (dispatch: (arg0: { type: string; payload: any }) => void) => {
    try {
      const res = await axios({
        method: "get",
        url: `${baseUri}/service-document/v1/persons/${fundId}/parts/${partId}`,
      });
      dispatch({
        type: GET_DOCUMENTS_PART,
        payload: res.data,
      });
      return true;
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
  };

export const addDocumentPart =
  (
    documentName: any,
    personId: any,
    partId: string,
    file: FormData,
    folderId?: any
  ) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      let data: any = {};
      if (!!personId) {
        data = {
          name: documentName,
          personId: personId,
        };
      } else {
        data = {
          name: documentName,
        };
      }
      file.append(
        "data",
        new Blob([JSON.stringify(data)], { type: "application/json" })
      );

      const res = await axios({
        method: "post",
        url: `${baseUri}/service-document/v1/persons/${personId}/parts/${partId}/${folderId}/document`,
        data: file,
      });
      dispatch({
        type: ADD_DOCUMENT_PART,
        payload: res.data,
      });
      return true;
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
    };

export const addEnvelopePart =
  (name: string, personId: string, partId: string) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = await axios.post(`${baseUri}/service-document/v1/persons/${personId}/parts/${partId}`, {
            isDeleted: false,
            comment: "",
            key: "customPartDocumentDefault",
            isPrivate: false,
            name: name,
          })
      dispatch({
        type: ADD_ENVELOPE_PART,
        payload: res.data,
      });
      return true;
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
  };

  export const getDocumentPart =
  (personId?: string, partId?: string, envelopeId?: string) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = await axios.get(
              `${baseUri}/service-document/v1/persons/${personId}/parts/${partId}/${envelopeId}`
            )
      dispatch({
        type: GET_DOCUMENT_PART,
        payload: res.data,
      });
      return true;
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
  };

export const deleteDocumentPart =
  (fundId?: string, partId?: string, envelopeId?: string, documentId?: string) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = await axios({
              method: "delete",
              url: `${baseUri}/service-document/v1/persons/${fundId}/parts/${partId}/${envelopeId}/document/${documentId}`,
            })
      dispatch({
        type: DELETE_DOCUMENT_PART,
        payload: res.data,
      });
      return true;
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
    };
 export const deleteEnvelopePart =
    (fundId?: string, partId?: string, envelopeId?: string) =>
    async (dispatch: (arg0: { type: any; payload: any }) => void) => {
      try {
        const res = await axios({
                method: "delete",
                url: `${baseUri}/service-document/v1/persons/${fundId}/parts/${partId}/${envelopeId}`,
              })
        dispatch({
          type: DELETE_ENVELOPE_PART,
          payload: res.data,
        });
        return true;
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
    };
